export const selectPrepareConsole = (prepare_console) => {
    return dispatch => {
        dispatch({
            type: 'MS_ADD_CONSOLE_DATA',
            payload: prepare_console
        });
    }
}